import { useCallback } from "react";

import { APITranscriptToken } from "../types/types";
import { camelCaseDeep } from "../utils/camel-case-deep";
import { snakeCaseDeep } from "../utils/snake-case-deep";
import { useAPIFetch } from "./use-api-fetch";

export interface AlignTokensParams {
  startMs?: number;
  startToken?: string; // JSON pointer
  endMs?: number;
  endToken?: string; // JSON pointer
}

export function useAlignTokens(): (
  transcriptId: string,
  options: AlignTokensParams,
) => Promise<APITranscriptToken[] | null> {
  const apiFetch = useAPIFetch(false);

  const alignTokens = useCallback(
    async (
      transcriptId: string,
      options: AlignTokensParams = {},
    ): Promise<APITranscriptToken[] | null> => {
      try {
        const response = await apiFetch.execute(
          `/api/v2/transcription/${transcriptId}/tokens?${new URLSearchParams(
            /* @ts-expect-error ts(2345) */
            snakeCaseDeep(options),
          )}`,
          { method: "GET" },
        );
        const json = await response.json();

        if (!response.ok) {
          throw new Error(`${json.status} ${json.msg_code} ${json.detail}`);
        }

        return camelCaseDeep(json) as APITranscriptToken[];
      } catch (error) {
        if (error instanceof Error) {
          if (error.name === "AbortError") return null;
          throw error;
        }
      }
      return null;
    },

    [apiFetch],
  );

  return alignTokens;
}
